


































import { Component, Vue, Mixins } from 'vue-property-decorator';
import NewsFeed from './NewsFeed.vue';
import Calendar from './Calendar.vue';
import MobileNewsFeed from './MobileNewsFeed.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import {Mutations, Buttons, Actions} from '@/ts/store/Constants';
import UserEventLogs from '@/components/NewsFeed/UserEventLogs.vue';
import { saveScroll } from '@/plugins/save-position';
import Bus from '@/plugins/event-bus';
import EULAAgreementModal from '@/components/Modal/EULAAgreementModal.vue';

@Component({
    components: {
        NewsFeed,
        Calendar,
        MobileNewsFeed,
        UserEventLogs,
        EULAAgreementModal,
    },
})
export default class Dashboard extends Mixins(DeviceMethods) {
    public staffDashboardId: string = 'hoc-adminapp-dashboard';
    public tenantDashboardId: string = 'hoc-tenantapp-dashboard';
    public ucla: boolean = true;

    get isStaff(): boolean {
        return this.$store.getters['User/getUser']
            ? !this.$store.getters['User/getUser'].isTenant
            : false;
    }

    get availableUpdateVisible() {
        return this.$store.getters['User/getAvailableUpdateVisible'];
    }

    get eulaAcceptedAt() {
        return this.$store.getters['Identities/getEulaAcceptedAt'];
    }

    constructor() {
        super();
    }

    get showEulaAgreement() {
        return this.eulaAcceptedAt == null;
    }

    set showEulaAgreement(value) {  
        this.$store.dispatch(Actions.ACCEPT_EULA);
    }

    public makeToolBar() {
        const leftButton     = this.isStaff ? Buttons.None : Buttons.CorporationLogo;
        const rightButton    = this.isStaff ? Buttons.UserProfileButton : Buttons.TenantDashboardButtons;
        const headerText     = this.isStaff ? 'Notifications' : '';
        const translationKey = this.isStaff ? 'notifications' : 'dashboard';

        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, leftButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, rightButton);
        this.$store.commit(Mutations.SET_HEADER_TEXT, Vue.i18n.translate(translationKey, headerText));
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
    }

    public created() {
        this.makeToolBar();
        Bus.$on('IdentityChangedMobile', (userType: string) => {
            this.makeToolBar();

            if (userType !== 'staff') {
                this.$store.dispatch(Actions.INITIALIZE_TENANT_LOG_SOCKET, this);
                this.$store.dispatch(Actions.FETCH_TENANTS_NOTIFICATIONS_UNREAD_COUNT);
                this.$store.dispatch(Actions.FETCH_TENANT_UPCOMING_EVENTS);
                this.$store.dispatch(Actions.FETCH_DASHBOARD_NOTIFICATIONS, {
                    page: 1,
                    type: ['event', 'information'],
                    hardReload: true,
                });
            }

            if (userType === 'staff') {
                this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffLanguageButton);
                this.$store.dispatch(Actions.FETCH_EVENT_LOGS, { withExceptions: false, additionalExceptions: [
                        'EVENT_COMMENT_NEW',
                        'NOTIFICATION_COMMENT_NEW',
                    ],
                });
                this.$store.dispatch(Actions.FETCH_ALL_USER_TICKETS, { vue: this, type: 'my' });
            }
        });
    }

    public beforeDestroy() {
        Bus.$off('IdentityChangedMobile');
    }

    public beforeRouteLeave(to, from, next) {
        const isStaff = this.$store.getters['User/getUser']
            ? !this.$store.getters['User/getUser'].isTenant
            : false;

        const mutation = isStaff
            ? Mutations.SET_STAFF_APP_PAGE_SCROLL_POSITION
            : Mutations.SET_TENANT_APP_PAGE_SCROLL_POSITION;

        const container = isStaff ? this.staffDashboardId : this.tenantDashboardId;

        saveScroll(container, mutation);

        next();
    }
}
